import type { CSSProperties } from "react";

export type IndividualBorderCssProperties = Pick<
  Partial<CSSProperties>,
  `border${"Top" | "Bottom" | "Left" | "Right"}${"Width" | "Color"}`
>;

export const setIndividualBorderProperties = (
  borderWidth: CSSProperties["borderWidth"],
  borderColor: CSSProperties["borderColor"],
): IndividualBorderCssProperties => ({
  borderTopColor: borderColor,
  borderTopWidth: borderWidth,
  borderBottomColor: borderColor,
  borderBottomWidth: borderWidth,
  borderLeftColor: borderColor,
  borderLeftWidth: borderWidth,
  borderRightColor: borderColor,
  borderRightWidth: borderWidth,
});

export type SingleBorderCssProperties = Pick<Partial<CSSProperties>, `border${"Width" | "Color"}`>;

export const setSingleBorderProperties = (
  borderWidth: CSSProperties["borderWidth"],
  borderColor: CSSProperties["borderColor"],
): SingleBorderCssProperties => ({
  borderColor: borderColor,
  borderWidth: borderWidth,
});
